import { MERCHANTS } from '@hero/constants';

import { DEFAULT_MERCHANT_NAME } from './constants';

const defaultMerchantName = process.env.REACT_APP_DEFAULT_MERCHANT_NAME || DEFAULT_MERCHANT_NAME;

function getMerchantName() {
  const merchantArray = process.env.REACT_APP_MERCHANT_LIST?.split('|');
  const merchantObject = {};
  merchantArray?.forEach(merchant => {
    const [name, domain] = merchant.split(':');

    if (Object.values(MERCHANTS).includes(name)) merchantObject[domain] = name;
  });

  return merchantObject[window.location.hostname] || defaultMerchantName;
}

export { defaultMerchantName, getMerchantName };
